import React from "react";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

import { MediaType } from "./types";

export const mediaTypeOptions = [
  { label: "Display", value: "display" },
  { label: "Video", value: "video" },
];

type MediaTypeselectorProps = {
  onChange: (mediaType: MediaType) => void;
  mediaType: MediaType;
  disableVideo?: boolean;
};

const MediaTypeSelector = ({ onChange, mediaType, disableVideo = false }: MediaTypeselectorProps) => {
  return (
    <FormControl fullWidth>
      <InputLabel id="demo-simple-select-label">Select Media Type</InputLabel>
      <Select
        labelId="demo-simple-select-label"
        id="demo-simple-select"
        value={mediaType}
        label="Media Type"
        onChange={(e) => {
          onChange(e.target.value as MediaType);
        }}
      >
        <MenuItem key={mediaTypeOptions[0].value} value={mediaTypeOptions[0].value}>
          {mediaTypeOptions[0].label}
        </MenuItem>
        {!disableVideo && (
          <MenuItem key={mediaTypeOptions[1].value} value={mediaTypeOptions[1].value}>
            {mediaTypeOptions[1].label}
          </MenuItem>
        )}
      </Select>
    </FormControl>
  );
};

export default MediaTypeSelector;
